import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mag6",
  "use": "icon-mag6-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mag6\"><path d=\"M512 64c-179.18 0-333.79 105.2-405.45 257.2a448 448 0 0 0 0 381.6C178.21 854.8 332.82 960 512 960c247.42 0 448-200.58 448-448S759.42 64 512 64zM128 512a382.18 382.18 0 0 1 21.22-126.25 128 128 0 0 1 0 252.51A382.18 382.18 0 0 1 128 512z m655.53 271.53A384.25 384.25 0 0 1 175.94 698a192.06 192.06 0 0 0 0-371.93 384.08 384.08 0 1 1 607.59 457.46z\" p-id=\"14591\" /><path d=\"M864 256H160v64h704v-64zM864 704H160v64h704v-64zM480 352H352v128h128V352zM480 544H352v128h128V544zM640 352H512v128h128V352zM640 544H512v128h128V544zM800 352H672v128h128V352zM800 544H672v128h128V544z\" p-id=\"14592\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-mag6.svg
// module id = mY5v
// module chunks = 175